const isSupportedTypes = (type, supportedTypes = ['SPC', 'KIT']) => {
    return supportedTypes.includes(type);
  };
  
export default isSupportedTypes;
  